import ContentElement from "./content-element.js";

declare global {
    interface JQuery {
        twentytwenty(options: any): JQuery;
    }
}

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-imagecomparison';

interface ImageComparisonConfig {
    defaultOffset: number;
    orientation: string;
    beforeLabel: string;
    afterLabel: string;
}

const defaultOptions: ImageComparisonConfig = {
    defaultOffset: 0.5,
    orientation: 'horizontal',
    beforeLabel: 'Vorher',
    afterLabel: 'Nachher'
};

class ImageComparison extends ContentElement {
    protected options: ImageComparisonConfig;
    protected items:Map<HTMLElement, HTMLElement> = new Map();

    public override init() {
        this.options = this.assignConfig<ImageComparisonConfig>(defaultOptions, this.config);
    }

    public override process() {
        const self = this;

        const containerEl = this.element.querySelector<HTMLElement>('.comparison-container');
        if(containerEl) {
            const imageHeights: number[] = [];
            self.element.querySelectorAll('img').forEach((el) => {
                imageHeights.push(el.offsetHeight);
            });
            const minHeight = Math.max(...imageHeights)
            containerEl.style.minHeight = minHeight+'px';

            jQuery(() => {
                jQuery(containerEl).twentytwenty({
                    default_offset_pct: this.options.defaultOffset,
                    orientation: this.options.orientation,
                    before_label: this.options.beforeLabel,
                    after_label: this.options.afterLabel
                });
            });
        }
    }
}

// Observe
ImageComparison.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { ImageComparisonConfig };
export default ImageComparison;
